import React from "react";
import ListTemplate from "components/ListTemplate";
import Filters from "./Filters";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { routes } from "utilities/routing/generatedRoutes";
import { DotLabel } from "components/Dot";
import { useLoaderData } from "react-router";

const AirportName = (props: { item: server.dto.Airport }) =>
  <span title={`SystemOne ID: ${props.item.airportId} | FlightStats ID: ${props.item.fs}`}>
    <DotLabel
      linkTo={routes.airport_Detail(props.item.airportId).absolute}
      dotColor={props.item.isActive ? "green" : "red"}
    >
      {props.item.name}
    </DotLabel>
  </span>

const AirportList = () => {
  const viewModel = useLoaderData<server.viewmodel.AirportListFrontModel>();

  return <ListTemplate
    perPage={50}
    title={RESX.Flight.Airports}
    filterSet="airport_List"
    defaultFilters={viewModel.defaultFilters}
    initialInstruction={viewModel.initialInstruction}
    fetchFunction={instruction => window.CoreApi.Airport.Paginated({ ...instruction, airportSize: "allAirports" })}
    getId={item => item.airportId}
    layout={{
      type: "table",
      columns: [{
        key: "name",
        header: RESX.GeneralLabels.Name,
        render: item => <AirportName item={item} />,
      }, {
        key: "iata",
        header: "IATA",
        render: item => item.iata,
        size: "auto"
      }, {
        key: "icao",
        header: "ICAO",
        render: item => item.icao,
        size: "auto"
      }, {
        key: "faa",
        header: "FAA",
        render: item => item.faa,
        size: "auto"
      }, {
        key: "country",
        header: RESX.Address.Country,
        render: item => item.countryName,
        size: "auto"
      }, {
        key: "state",
        header: RESX.Address.State,
        render: item => item.stateName,
        size: "auto"
      }, {
        key: "city",
        header: RESX.Address.City,
        render: item => item.city,
        size: "auto"
      }, {
        key: "timezone",
        header: RESX.DateTime.Timezone,
        render: item => item.timeZoneRegionName,
        size: "auto"
      }, {
        key: "classification",
        header: "Classification",
        render: item => item.classification,
        size: "auto"
      }],
    }}
    filters={<Filters />}
    functions={{
      mapResponseToFilterValues,
      mapFilterValuesToInstruction
    }}
  />
}

export default AirportList;